import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { ApifirstService } from 'src/app/service/apifirst.service';
import { RpcClientService} from 'src/app/service/rpc-client.service'
@Component({
  selector: 'app-symptoms',
  templateUrl: './symptoms.component.html',
  styleUrls: ['./symptoms.component.scss']
})
export class SymptomsComponent implements OnInit {
  public a: any;
  public childList: any;
  public childList1: any;
  public childList2: any;
  public childList3: any;
  public childList4: any;
  public isShowChildNodes1 = false;
  public isShowChildNodes2 = false;
  public isShowChildNodes3 = false;
  public isShowChildNodes4 = false;
  public isShowChildNodes5 = false;
  public isShowLink = '';
  public isHideLink = false;
  public isShowLink1 = '';
  public isHideLink1 = false;
  public isShowLink2 = '';
  public isShowLink3 = '';
  public isShowLink4 = '';
  public isShowLink5 = '';
  public isHideLink2 = false;
  public isHideLink3 = false;
  public isHideLink4 = false;
  public isHideLink5 = false;
  public isShowText = false;
  public isShowText1 = false;
  public isShowText2 = false;
  public isShowText3 = false;
  public isShowText4 = false;
  public isShowText5 = false;
  public count: any;
  public infotab: boolean = false;
  public hintstab: boolean = false;
  public submittab: boolean = false;
  public isShowChildNodes = false;
  public symptomsSelected = 0;
  constructor(private api: ApifirstService, private router: Router, private rpcClient: RpcClientService) { }
  public selectedSymptomIdlist: number[] = [];
  public parentIdList: number[] = [];
  public parentIdArrowList: number[] = [];
  globalManagedRes:any;
  b: any;
  symptomjson: any
  childnode: any
  show_val: string[] = [];
  crumbChild: string[] = [];
  val: any
  oldParent: any
  parentSymptomName = ''
  child: any = true
  clickVal: any
  selectedbutton: any
  crumbParent: any
  crumb: string[] = [];
  buttonkeys: string[] = [];
  uniqueSelectedIdList: any
  nochild: any;
  showArrow = false;
  showArrowFirstFuncCall = false;
  showArrowSecFuncCall = false;
  showArrowThirdFuncCall = false;
  showArrowFourthFuncCall = false;
  showArrowFifthFuncCall = false;
  showArrowSixthFuncCall = false;

  changecolor: any = false;
  colorSelected = false;
  count1 = 0;
  toggle = true;
  status = "Enable"
  infosymptomselected: any;
  navigateSymptom = "";
  success: any;
  showLoader: any = true
  isCrumb = false;
  symptomSelectedFirstName: any;
  isAvailable = false;
  fromCapture = false;
  twoDimensionalParent: any = [];
  oneDimensionalParent: any = [];
  tempTwoDimensionalParent: any = [];
  tempSymptomChildId: any = []
  tempParentId: any
  language: any;
  country: any
  vin:any
  dealerCode:any
  countrythree:any
  modelYear:any
  username:any
  vindetails:any
  vehicle:any
  fromResume:any;
  isEnableService=false;
  targetEngineServiceResponseObj:any
  idsFdspEngineServiceResponseObj:any
  ptsEngineServiceResponseObj:any
  fdspEngineServiceResponseObj:any
  globalServices:any=[];
  getDiagnosticCandidate: boolean = false;
  

  ngOnInit(): void {
    this.initialiseAll();
    this.api.fromResume.subscribe(data=>this.fromResume = data);
    //  this.symp();
    const req = {
      "sessionId": localStorage.getItem("sessionID"),
      "pageid": "4"
    }
    this.api.updatePage(req).subscribe(data => { })
    this.api.tokenObj.subscribe((data) => {
      let c: any
      c = data
      this.language = c.language
      this.country = c.country
      this.dealerCode = c.dealerCode
      this.countrythree = c.countryThree
      this.vin = c.vin
      this.username = c.username
    })
    this.api.serviceNameListservice.subscribe((data) =>{
      this.globalServices=data
       for (let obj of this.globalServices){
        if (obj.serviceName=="Target Engine Service"){
          this.targetEngineServiceResponseObj=obj;
        }
        if (obj.serviceName=="FDSP Service"){
          this.fdspEngineServiceResponseObj=obj;
        }
      }
      
     
    })
    
    this.api.getGlobalManagedServicesDetails(this.fdspEngineServiceResponseObj.id).subscribe((data) => {
      this.globalManagedRes = data;
      if (!this.globalManagedRes) {
        this.isEnableService = true;
      } else {
        this.isEnableService = false;
      }
      if (this.isEnableService || this.fromResume){
      this.api.fromCapture.subscribe((data) => {
      this.fromCapture = data;
      if (!this.fromCapture) {
        this.parentIdList = []
        this.selectedSymptomIdlist = []
        this.symptomsSelected = 0
      }

    })
    
      if (this.fromCapture) {
        this.api.navigateSymptom.subscribe((data) => {
          this.navigateSymptom = data
        })
        if (this.navigateSymptom === 'sym') {
          this.api.symptomSubject.subscribe((data) => {
            this.infosymptomselected = data
            if (data > 0) {
              this.symptomsSelected = this.infosymptomselected;
            }
            else {
              this.symptomsSelected = 0;
            }
          })
          this.api.ParentsymptomSubject.subscribe((data) => {
            this.oneDimensionalParent = data
            this.parentIdList = this.oneDimensionalParent;
          })
          this.api.listsymptomSubject.subscribe((data) => {
            this.selectedSymptomIdlist = data
            this.uniqueSelectedIdList = new Set(this.selectedSymptomIdlist);
          })
          this.api.tempSymptomSubject.subscribe((data) => {
            this.tempSymptomChildId = data
            console.log(this.tempSymptomChildId,"temp");
          })
        }

      }
      else {
        this.parentIdList = []
        this.selectedSymptomIdlist = []
        this.symptomsSelected = 0
      }
      this.api.navigateSymptom.subscribe((data) => {
        this.navigateSymptom = data
      })
    this.symptomApi();
  }
  else {
    this.api.selectedGlobalServices.next('FDSP Engine Service')
    this.router.navigate(['/globalServiceEnabled']);
  }
    })
  }

  initialiseAll(){
        this.oneDimensionalParent = [];
        this.parentIdList = [];
        this.symptomsSelected =0;
        this.selectedSymptomIdlist = [];
        this.uniqueSelectedIdList = [];
        this.twoDimensionalParent = [];
        this.tempSymptomChildId = [];
        this.tempTwoDimensionalParent = [];
  }
  showNoconnection: any
  clickShowNoconnection = false
  procedureApi(str: string) {
    this.rpcClient.HideFDRSIconIfNotConnected();
    this.getDiagnosticCandidate = true;
    this.api.diagnosticViewFaultFound.next({ 
      "status": '',
      "isFound": false,
      "faultString": ''
    });
    this.api.fromResume.next(false);
    this.api.otxStateChangeObj.next([{}]);
    if (str == 'continue' && this.symptomsSelected == 0) {
      this.api.isSymptomClickHereLinkEmpty.next(false);
      this.api.symptomSubject.next(this.symptomsSelected);
      this.api.ParentsymptomSubject.next(this.parentIdList)
      this.api.listsymptomSubject.next(this.selectedSymptomIdlist);
      this.api.pageData.next('');
      this.api.getUnselectedSymptomsApi(localStorage.getItem("sessionID")).subscribe(data => { 
        this.getDiagnosticCandidate = false;
        this.router.navigate(['/info']);
      })
    } else {
      var symptomandsession: any
      console.log(localStorage.getItem("sessionID"), this.selectedSymptomIdlist)
      let myArray = Array.from(this.uniqueSelectedIdList);
      console.log(myArray)
      console.log(this.parentIdList)
      symptomandsession = {
        "symptomId": myArray,
        "sessionId": localStorage.getItem("sessionID"),
        "parentchildsymptomsidList":this.parentIdList
      }
      console.log(myArray, "myArray")
      console.log(this.parentIdList, "parents")
      this.api.getGlobalManagedServicesDetails(this.targetEngineServiceResponseObj.id).subscribe((data) => {
        this.globalManagedRes=data;
        if (!this.globalManagedRes){
           this.isEnableService =true;
        } else {
            this.isEnableService =false;
        }

        if (this.isEnableService){
          this.api.selectedSymptoms(symptomandsession).subscribe((data) => {
            this.getDiagnosticCandidate = false;
            this.success = data;
            console.log("success ratings:", this.success)
            console.log(this.success, "candidates success")
            this.api.isSymptomClickHereLinkEmpty.next(true);
            this.api.pageData.next(this.success);
            this.router.navigate(['/info']);
    
          }, (error) => {
            this.getDiagnosticCandidate = false;
            this.api.showNoconnection.next(true)
            this.clickShowNoconnection = false
            this.router.navigate(['/info']);
          })
        } else {
          this.getDiagnosticCandidate = false;
          this.api.selectedGlobalServices.next('Target Engine Service')
          this.router.navigate(['/globalServiceEnabled']);
        }
      });
 
    }

  }

  symptomApi() {
    this.show_val = this.a
    this.api.getSymptoms(this.language, this.country).subscribe(
      (data) => {
        this.showLoader = false
        this.a = data;
        console.log(data, "symptomlist")
        let c = false;
        console.log(this.a)
        this.a.push(c);
        if (this.navigateSymptom === 'sym') {
          for (let g of this.selectedSymptomIdlist) {
            for (let f of this.a) {
              if (g == f) {
                // this.a.c=true
                // this.a.
              }
            }
          }
        }
        if (this.a.includes(false)) {
          this.b = this.a.splice(13)
        }

        //created temsymptIdlist for resume
        if(this.fromResume){
          for(let id of this.a){
            for(let sym of this.parentIdList){
             if(id.parentId == sym){
               for(let i of id.childNode){
                 for(let j of this.parentIdList){
                   if(i.symptomId == j){
                     if(i.childNode.length == 0){
                      this.tempSymptomChildId.push({ symptomId: sym, childSymptomId:j })
                      this.tempSymptomChildId.push({ symptomId: j, childSymptomId:j })
                     }
                     else{

                       for(let s of i.childNode){
                         for(let j of this.parentIdList){
                           if(s.symptomId == j){
                            if(s.childNode.length == 0){
                              this.tempSymptomChildId.push({ symptomId: sym, childSymptomId:j })
                              this.tempSymptomChildId.push({ symptomId: i.symptomId, childSymptomId:j })
                              this.tempSymptomChildId.push({ symptomId: j, childSymptomId:j })
                              
                             }
                             else{
                               for(let a of s.childNode){
                                 for(let j of this.parentIdList){
                                   if(a.symptomId == j){
                                    if(a.childNode.length == 0){
                                      this.tempSymptomChildId.push({ symptomId: sym, childSymptomId:j })
                                      this.tempSymptomChildId.push({ symptomId: i.symptomId, childSymptomId:j })
                                      this.tempSymptomChildId.push({ symptomId: s.symptomId, childSymptomId:j })
                                      this.tempSymptomChildId.push({ symptomId: j, childSymptomId:j })
                                     }
                                     else{
                                       for(let b of a.childNode){
                                         for(let j of this.parentIdList){
                                           if(b.symptomId == j){
                                            if(b.childNode.length == 0){
                                              this.tempSymptomChildId.push({ symptomId: sym, childSymptomId:j })
                                              this.tempSymptomChildId.push({ symptomId: i.symptomId, childSymptomId:j })
                                              this.tempSymptomChildId.push({ symptomId: s.symptomId, childSymptomId:j })
                                              this.tempSymptomChildId.push({ symptomId: a.symptomId, childSymptomId:j })
                                              this.tempSymptomChildId.push({ symptomId: j, childSymptomId:j })
                                             }
                                             else{
                                               for(let c of b.childNode){
                                                 for(let j of this.parentIdList){
                                                   if(c.symptomId == j){
                                                    if(c.childNode.length == 0){
                                                      this.tempSymptomChildId.push({ symptomId: sym, childSymptomId:j })
                                                      this.tempSymptomChildId.push({ symptomId: i.symptomId, childSymptomId:j })
                                                      this.tempSymptomChildId.push({ symptomId: s.symptomId, childSymptomId:j })
                                                      this.tempSymptomChildId.push({ symptomId: a.symptomId, childSymptomId:j })
                                                      this.tempSymptomChildId.push({ symptomId: b.symptomId, childSymptomId:j })
                                                      this.tempSymptomChildId.push({ symptomId: j, childSymptomId:j })
                                                     }
                                                     else{
                                                       for(let d of c.childNode){
                                                         for(let j of this.parentIdList){
                                                           if(d.symptomId == j){
                                                            if(d.childNode.length == 0){
                                                              this.tempSymptomChildId.push({ symptomId: sym, childSymptomId:j })
                                                              this.tempSymptomChildId.push({ symptomId: i.symptomId, childSymptomId:j })
                                                              this.tempSymptomChildId.push({ symptomId: s.symptomId, childSymptomId:j })
                                                              this.tempSymptomChildId.push({ symptomId: a.symptomId, childSymptomId:j })
                                                              this.tempSymptomChildId.push({ symptomId: b.symptomId, childSymptomId:j })
                                                              this.tempSymptomChildId.push({ symptomId: c.symptomId, childSymptomId:j })
                                                              this.tempSymptomChildId.push({ symptomId: j, childSymptomId:j })
                                                             }
                                                             else{
                                                               for(let f of d.childNode){
                                                                 for(let j of this.parentIdList){
                                                                   if(f.symptomId == j){
                                                                    if(f.childNode.length == 0){
                                                                      this.tempSymptomChildId.push({ symptomId: sym, childSymptomId:j })
                                                                      this.tempSymptomChildId.push({ symptomId: i.symptomId, childSymptomId:j })
                                                                      this.tempSymptomChildId.push({ symptomId: s.symptomId, childSymptomId:j })
                                                                      this.tempSymptomChildId.push({ symptomId: a.symptomId, childSymptomId:j })
                                                                      this.tempSymptomChildId.push({ symptomId: b.symptomId, childSymptomId:j })
                                                                      this.tempSymptomChildId.push({ symptomId: c.symptomId, childSymptomId:j })
                                                                      this.tempSymptomChildId.push({ symptomId: d.symptomId, childSymptomId:j })
                                                                      this.tempSymptomChildId.push({ symptomId: j, childSymptomId:j })
                                                                     }
                                                                     else{
                                                                       for(let e of f.childNode){
                                                                         for(let j of this.parentIdList){
                                                                           if(e.symptomId == j){
                                                                            if(e.childNode.length == 0){
                                                                              this.tempSymptomChildId.push({ symptomId: sym, childSymptomId:j })
                                                                              this.tempSymptomChildId.push({ symptomId: i.symptomId, childSymptomId:j })
                                                                              this.tempSymptomChildId.push({ symptomId: s.symptomId, childSymptomId:j })
                                                                              this.tempSymptomChildId.push({ symptomId: a.symptomId, childSymptomId:j })
                                                                              this.tempSymptomChildId.push({ symptomId: b.symptomId, childSymptomId:j })
                                                                              this.tempSymptomChildId.push({ symptomId: c.symptomId, childSymptomId:j })
                                                                              this.tempSymptomChildId.push({ symptomId: d.symptomId, childSymptomId:j })
                                                                              this.tempSymptomChildId.push({ symptomId: f.symptomId, childSymptomId:j })
                                                                              this.tempSymptomChildId.push({ symptomId: j, childSymptomId:j })
                                                                             }
                                                                           }
                                                                         }
                                                                       }
                                                                     }
                                                                   }
                                                                 }
                                                               }
                                                             }
                                                           }
                                                         }
                                                       }
                                                     }
                                                   }
                                                 }
                                               }
                                             }
                                           }
                                         }
                                       }
                                     }
                                   }
                                 }
                               }
                             }
                           }
                         }
                       }
                     }
                   }
                 }
               }
             }
            }
          }
          console.log(this.tempSymptomChildId,"temp after resume");
        }

        //   console.log("data", this.a)
        //   this.showFirst()
        //   this.crumb.splice(0, 1)
        //   this.buttonkeys.splice(0, 1)
        //   this.crumbChild.splice(0, 1)
      }, (error) => {
        console.error("error getting json", error)
      })
  }




  firstChildNode(id: number, childNodes: any, name: string, parentId: number) {

    let twoD = {
      parentId: parentId,
      symptomId: id,
    }
    this.twoDimensionalParent.push(twoD)

    if (childNodes == null || childNodes.length == 0) {
      this.isShowChildNodes1 = false;
      this.isShowChildNodes = false
      this.isShowChildNodes2 = false;
      this.isShowChildNodes3 = false;
      this.isShowChildNodes4 = false;
      this.isShowChildNodes5 = false;
      this.isHideLink = false;
      if (this.selectedSymptomIdlist.includes(id) || this.parentIdList.includes(id)) {
        this.symptomsSelected--;

        this.selectedSymptomIdlist.splice(id, 2);

        //  this.parentIdList.splice(ind,2)
        this.parentIdList = this.parentIdList.filter((key) => {
          return key != id
        })


        if (this.symptomsSelected == 0) {
          this.selectedSymptomIdlist = [];
          this.oldParent = this.parentIdList
          this.parentIdList = [];

        }

        this.oneDimensionalParent = []
        const index = this.selectedSymptomIdlist.indexOf(id, 0);
        // const index1 = this.oneDimensionalParent.indexOf(id, 0);
        const index2 = this.twoDimensionalParent.findIndex((o: any) => {
          return o.symptomId == id
        })
        this.tempSymptomChildId = this.tempSymptomChildId.filter((data: any) => {
          return data.childSymptomId != id
        })


        for (let twod of this.tempSymptomChildId) {
          this.oneDimensionalParent.push(twod.symptomId)
        }
        this.oneDimensionalParent = this.oneDimensionalParent.filter((data: any, index: any) => {
          return this.oneDimensionalParent.indexOf(data) === index
        })

        this.parentIdList = this.oneDimensionalParent
        if (index > -1 || index2 > -1) {
          this.selectedSymptomIdlist.splice(index, 1);

          let tempTwoDimensionalParent: any = []
          for (let i of this.twoDimensionalParent) {
            if (i.symptomId != id) {
              tempTwoDimensionalParent.push(i)
            }
          }


          this.uniqueSelectedIdList = new Set(this.selectedSymptomIdlist);
          // this.api.tempSymptomSubject.next(this.tempSymptomChildId)
          this.api.symptomSubject.next(this.symptomsSelected);
          this.api.listsymptomSubject.next(this.selectedSymptomIdlist);
          this.api.ParentsymptomSubject.next(this.parentIdList);
          this.api.tempSymptomSubject.next(this.tempSymptomChildId)
          return;
        }
      } else {
        this.symptomsSelected++;

        this.tempParentId = parentId
        var tempSymptomId = id
        this.tempSymptomChildId.push({ symptomId: id, childSymptomId: id })
        while (this.tempParentId != tempSymptomId) {
          this.tempSymptomChildId.push({ symptomId: this.tempParentId, childSymptomId: id })
          tempSymptomId = this.tempParentId;
          for (let data of this.twoDimensionalParent) {
            if (data.symptomId == this.tempParentId) {

              this.tempParentId = data.parentId
              break;
            }
          }

        }

        if (this.symptomsSelected > 0) {
          for (let twod of this.tempSymptomChildId) {
            this.oneDimensionalParent.push(twod.symptomId)
          }
          this.oneDimensionalParent = this.oneDimensionalParent.filter((data: any, index: any) => {
            return this.oneDimensionalParent.indexOf(data) === index
          })
          this.parentIdList = this.oneDimensionalParent
        }


        //this.parentIdList.push(id);
        this.api.ParentsymptomSubject.next(this.parentIdList)
        this.api.tempSymptomSubject.next(this.tempSymptomChildId)
        this.selectedSymptomIdlist.push(id);
        this.uniqueSelectedIdList = new Set(this.selectedSymptomIdlist);
        this.api.symptomSubject.next(this.symptomsSelected);
        this.api.listsymptomSubject.next(this.selectedSymptomIdlist)
        return;
      }
    } else if (childNodes && childNodes.length > 0) {
      this.api.symptomName.next(name)
      this.showArrowFirstFuncCall = true
      this.showArrow = true
      this.isCrumb = false;
      if (name == 'Customer comfort and entertainment' || name == "Vehicle trim and exterior finish" || name == "Driver aids and information") {
        this.isCrumb = true;
      }

      this.childList = childNodes;
      this.isShowChildNodes1 = false;
      this.isShowChildNodes = true;
      this.isShowChildNodes2 = false;
      this.isShowChildNodes3 = false;
      this.isShowChildNodes4 = false;
      this.isShowChildNodes5 = false;
      this.isHideLink = true;
      this.isHideLink1 = true;
      this.isShowLink = name;
      this.isShowText = true;
      // this.parentIdList.push(id);
      this.parentIdArrowList = this.parentIdList

      this.uniqueSelectedIdList = new Set(this.parentIdList);
      this.api.symptomSubject.next(this.symptomsSelected);
      this.api.ParentsymptomSubject.next(this.parentIdList)
    }
  }
  secondChildNode(id: number, childNodes: any, name: string, parentId: number) {
   
   
    let twoD = {
      parentId: parentId,
      symptomId: id,
    }
    this.twoDimensionalParent.push(twoD)

    this.parentIdArrowList = []
    if (childNodes == null || childNodes.length == 0) {
      this.isShowChildNodes1 = false;
      this.isShowChildNodes = true;
      this.isShowChildNodes2 = false;
      this.isShowChildNodes3 = false;
      this.isShowChildNodes4 = false;
      this.isShowChildNodes5 = false;
      this.isHideLink1 = false;
      this.isShowText = true;
      if (this.selectedSymptomIdlist.includes(id) || this.parentIdList.includes(id)) {
        this.symptomsSelected--;

        this.selectedSymptomIdlist.splice(id, 2);

        //  this.parentIdList.splice(ind,2)
        this.parentIdList = this.parentIdList.filter((key) => {
          return key != id
        })


        if (this.symptomsSelected == 0) {
          this.selectedSymptomIdlist = [];
          this.oldParent = this.parentIdList
          this.parentIdList = [];

        }

        this.oneDimensionalParent = []
        const index = this.selectedSymptomIdlist.indexOf(id, 0);
        // const index1 = this.oneDimensionalParent.indexOf(id, 0);
        const index2 = this.twoDimensionalParent.findIndex((o: any) => {
          return o.symptomId == id
        })
        this.tempSymptomChildId = this.tempSymptomChildId.filter((data: any) => {
          return data.childSymptomId != id
        })


        for (let twod of this.tempSymptomChildId) {
          this.oneDimensionalParent.push(twod.symptomId)
        }
        this.oneDimensionalParent = this.oneDimensionalParent.filter((data: any, index: any) => {
          return this.oneDimensionalParent.indexOf(data) === index
        })
        //this.parentIdList = this.oneDimensionalParent
        if (index > -1 || index2 > -1) {
          this.selectedSymptomIdlist.splice(index, 1);

          let tempTwoDimensionalParent: any = []
          for (let i of this.twoDimensionalParent) {
            if (i.symptomId != id) {
              tempTwoDimensionalParent.push(i)
            }
          }


          this.uniqueSelectedIdList = new Set(this.selectedSymptomIdlist);
          this.api.symptomSubject.next(this.symptomsSelected);
          this.api.listsymptomSubject.next(this.selectedSymptomIdlist);
          this.api.ParentsymptomSubject.next(this.parentIdList);
          return;
        }
      } else {
       
        this.symptomsSelected++;

        this.tempParentId = parentId
        var tempSymptomId = id
        this.tempSymptomChildId.push({ symptomId: id, childSymptomId: id })
        while (this.tempParentId != tempSymptomId) {
          this.tempSymptomChildId.push({ symptomId: this.tempParentId, childSymptomId: id })
          tempSymptomId = this.tempParentId;
          for (let data of this.twoDimensionalParent) {
            if (data.symptomId == this.tempParentId) {

              this.tempParentId = data.parentId
              break;
            }
          }

        }

        if (this.symptomsSelected > 0) {
          for (let twod of this.tempSymptomChildId) {
            this.oneDimensionalParent.push(twod.symptomId)
          }
          this.oneDimensionalParent = this.oneDimensionalParent.filter((data: any, index: any) => {
            return this.oneDimensionalParent.indexOf(data) === index
          })
          this.parentIdList = this.oneDimensionalParent
        }


        //this.parentIdList.push(id);
        this.api.ParentsymptomSubject.next(this.parentIdList)
        this.selectedSymptomIdlist.push(id);
        this.uniqueSelectedIdList = new Set(this.selectedSymptomIdlist);
        this.api.symptomSubject.next(this.symptomsSelected);
        this.api.listsymptomSubject.next(this.selectedSymptomIdlist)
        return;
      }
    } else if (childNodes && childNodes.length > 0) {
      this.showArrow = true;
      this.showArrowSecFuncCall = true;
      this.showArrowFirstFuncCall = false;
      this.childList1 = childNodes;
      this.isShowChildNodes1 = true;
      this.isShowChildNodes = false;
      this.isShowChildNodes2 = false;
      this.isShowChildNodes3 = false;
      this.isShowChildNodes4 = false;
      this.isShowChildNodes5 = false;
      this.isHideLink = false;
      this.isShowText = false;
      this.isShowText1 = true;
      this.isHideLink1 = true;
      this.isHideLink2 = false;
      this.isShowLink1 = name;
      // this.parentIdList.push(id);
      this.parentIdArrowList = this.parentIdList
      this.uniqueSelectedIdList = new Set(this.parentIdList);
      this.api.symptomSubject.next(this.symptomsSelected);
      this.api.ParentsymptomSubject.next(this.parentIdList)

    }
    this.isHideLink1 = false;


  }


  thirdChildNode(ind: number, id: number, childNodes: any, name: string, parentId: number) {

    let twoD = {
      parentId: parentId,
      symptomId: id
    }

    this.twoDimensionalParent.push(twoD)

    if (childNodes == null || childNodes.length == 0) {
      this.isShowChildNodes1 = true;
      this.isShowChildNodes = false;
      this.isShowChildNodes2 = false;
      this.isShowChildNodes3 = false;
      this.isShowChildNodes4 = false;
      this.isShowChildNodes5 = false;
      if (this.selectedSymptomIdlist.includes(id) || this.parentIdList.includes(id)) {
        this.symptomsSelected--;

        this.selectedSymptomIdlist.splice(id, 2);

        //  this.parentIdList.splice(ind,2)
        this.parentIdList = this.parentIdList.filter((key) => {
          return key != id
        })


        if (this.symptomsSelected == 0) {
          this.selectedSymptomIdlist = [];
          this.oldParent = this.parentIdList
          this.parentIdList = [];

        }

        this.oneDimensionalParent = []
        const index = this.selectedSymptomIdlist.indexOf(id, 0);
        // const index1 = this.oneDimensionalParent.indexOf(id, 0);
        const index2 = this.twoDimensionalParent.findIndex((o: any) => {
          return o.symptomId == id
        })
        this.tempSymptomChildId = this.tempSymptomChildId.filter((data: any) => {
          return data.childSymptomId != id
        })


        for (let twod of this.tempSymptomChildId) {
          this.oneDimensionalParent.push(twod.symptomId)
        }
        this.oneDimensionalParent = this.oneDimensionalParent.filter((data: any, index: any) => {
          return this.oneDimensionalParent.indexOf(data) === index
        })

        this.parentIdList = this.oneDimensionalParent
        if (index > -1 || index2 > -1) {
          this.selectedSymptomIdlist.splice(index, 1);

          let tempTwoDimensionalParent: any = []
          for (let i of this.twoDimensionalParent) {
            if (i.symptomId != id) {
              tempTwoDimensionalParent.push(i)
            }
          }


          this.uniqueSelectedIdList = new Set(this.selectedSymptomIdlist);
          // this.api.tempSymptomSubject.next(this.tempSymptomChildId)
          this.api.symptomSubject.next(this.symptomsSelected);
          this.api.listsymptomSubject.next(this.selectedSymptomIdlist);
          this.api.ParentsymptomSubject.next(this.parentIdList);
          this.api.tempSymptomSubject.next(this.tempSymptomChildId)
          return;
        }
      } else {
        this.symptomsSelected++;

        this.tempParentId = parentId
        var tempSymptomId = id
        this.tempSymptomChildId.push({ symptomId: id, childSymptomId: id })
        while (this.tempParentId != tempSymptomId) {
          this.tempSymptomChildId.push({ symptomId: this.tempParentId, childSymptomId: id })
          tempSymptomId = this.tempParentId;
          for (let data of this.twoDimensionalParent) {
            if (data.symptomId == this.tempParentId) {

              this.tempParentId = data.parentId
              break;
            }
          }

        }

        if (this.symptomsSelected > 0) {
          for (let twod of this.tempSymptomChildId) {
            this.oneDimensionalParent.push(twod.symptomId)
          }
          this.oneDimensionalParent = this.oneDimensionalParent.filter((data: any, index: any) => {
            return this.oneDimensionalParent.indexOf(data) === index
          })
          this.parentIdList = this.oneDimensionalParent
        }


        //this.parentIdList.push(id);
        this.api.ParentsymptomSubject.next(this.parentIdList)
        this.api.tempSymptomSubject.next(this.tempSymptomChildId)
        this.selectedSymptomIdlist.push(id);
        this.uniqueSelectedIdList = new Set(this.selectedSymptomIdlist);
        this.api.symptomSubject.next(this.symptomsSelected);
        this.api.listsymptomSubject.next(this.selectedSymptomIdlist)
        return;
      }
    } else if (childNodes && childNodes.length > 0) {
      this.showArrow = true
      this.showArrowThirdFuncCall = true
      this.showArrowFirstFuncCall = false;
      this.showArrowSecFuncCall = false;
      this.isShowChildNodes1 = false;
      this.isShowChildNodes = false;
      this.isShowChildNodes2 = true;
      this.isShowChildNodes3 = false;
      this.isShowChildNodes4 = false;
      this.isShowChildNodes5 = false;
      this.childList2 = childNodes;
      this.isHideLink = false;
      this.isShowText = false;
      this.isShowText1 = false;
      this.isShowText2 = true;
      this.isHideLink1 = false;
      this.isHideLink2 = false;
      this.isShowLink2 = name;
      // this.parentIdList.push(id);
      this.uniqueSelectedIdList = new Set(this.parentIdList);
      this.api.symptomSubject.next(this.symptomsSelected);
      this.api.ParentsymptomSubject.next(this.parentIdList)
      this.api.tempSymptomSubject.next(this.tempSymptomChildId)
    }
  }

  crumbArrowFirst() {

    if (this.symptomsSelected == 0) {
      this.selectedSymptomIdlist = [];
      this.parentIdList = [];
    }
    this.showArrow = false
    this.isShowLink = '';
    this.isShowLink1 = '';
    this.isShowLink2 = '';
    this.isShowLink3 = '';
    this.isShowLink4 = '';
    this.isShowLink5 = '';
    this.isShowText = false;
    this.isShowChildNodes = false;
    this.isShowChildNodes1 = false;
    this.isShowChildNodes2 = false;
    this.isShowChildNodes3 = false;
    this.isShowChildNodes4 = false;
    this.isShowChildNodes5 = false;
    this.isHideLink = true;
    this.isHideLink1 = true;
    this.isHideLink2 = true;

  }
  crumbArrowSecond() {

    this.parentIdArrowList = []
    if (this.symptomsSelected == 0) {
      this.selectedSymptomIdlist = [];
      this.parentIdList = [];
    }
    this.showArrowFirstFuncCall = true
    this.showArrowSecFuncCall = false
    this.showArrowThirdFuncCall = false
    this.showArrowFourthFuncCall = false
    this.showArrowFifthFuncCall = false
    this.isShowText = true;
    this.isShowText1 = false;
    this.isShowLink1 = '';
    this.isShowLink2 = '';
    this.isShowLink3 = '';
    this.isShowLink4 = '';
    this.isShowLink5 = '';
    this.isShowChildNodes = true;
    this.isShowChildNodes1 = false;
    this.isShowChildNodes2 = false;
    this.isShowChildNodes3 = false;
    this.isShowChildNodes4 = false;
    this.isShowChildNodes5 = false;

  }
  crumbArrowThird() {

    if (this.symptomsSelected == 0) {
      this.selectedSymptomIdlist = [];
      this.parentIdList = [];
    }

    this.showArrow = true
    this.showArrowFirstFuncCall = false
    this.showArrowSecFuncCall = true;
    this.showArrowThirdFuncCall = false
    this.showArrowFourthFuncCall = false
    this.showArrowFifthFuncCall = false

    this.isShowText1 = true;
    this.isShowLink2 = '';
    this.isShowLink3 = '';
    this.isShowLink4 = '';
    this.isShowLink5 = '';
    this.isShowChildNodes = false;
    this.isShowChildNodes1 = true;
    this.isShowChildNodes2 = false;
    this.isShowChildNodes3 = false;
    this.isShowChildNodes4 = false;
    this.isShowChildNodes5 = false;

  }
  crumbArrowFourth() {

    if (this.symptomsSelected == 0) {
      this.selectedSymptomIdlist = [];
      this.parentIdList = [];
    }
    this.showArrow = true
    this.showArrowFirstFuncCall = false
    this.showArrowSecFuncCall = false;
    this.showArrowThirdFuncCall = true;
    this.showArrowFourthFuncCall = false
    this.showArrowFifthFuncCall = false
    this.isShowText2 = true;
    this.isShowLink3 = '';
    this.isShowLink4 = '';
    this.isShowLink5 = '';
    this.isShowChildNodes = false;
    this.isShowChildNodes1 = false;
    this.isShowChildNodes2 = true;
    this.isShowChildNodes3 = false;
    this.isShowChildNodes4 = false;
    this.isShowChildNodes5 = false;

  }
  crumbArrowFifth() {

    if (this.symptomsSelected == 0) {
      this.selectedSymptomIdlist = [];
      this.parentIdList = [];
    }
    this.showArrow = true
    this.showArrowFirstFuncCall = false
    this.showArrowSecFuncCall = false;
    this.showArrowThirdFuncCall = false
    this.showArrowFourthFuncCall = true
    this.showArrowFifthFuncCall = false
    this.isShowText3 = true;
    this.isShowLink4 = '';
    this.isShowLink5 = '';
    this.isShowChildNodes = false;
    this.isShowChildNodes1 = false;
    this.isShowChildNodes2 = false;
    this.isShowChildNodes3 = true;
    this.isShowChildNodes4 = false;
    this.isShowChildNodes5 = false;

  }
  crumbArrowSixth() {

    if (this.symptomsSelected == 0) {
      this.selectedSymptomIdlist = [];
      this.parentIdList = [];
    }
    this.showArrow = true
    this.showArrowFirstFuncCall = false
    this.showArrowSecFuncCall = false;
    this.showArrowThirdFuncCall = false
    this.showArrowFourthFuncCall = false
    this.showArrowFifthFuncCall = true
    this.isShowText4 = true;
    this.isShowLink5 = '';
    this.isShowChildNodes = false;
    this.isShowChildNodes1 = false;
    this.isShowChildNodes2 = false;
    this.isShowChildNodes3 = false;
    this.isShowChildNodes4 = true;
    this.isShowChildNodes5 = false;

  }
  abcde(id: string) {

    if (id) {
      this.symptomsSelected++;
    }
  }


  colorChange() {

    this.changecolor = true;
  }

  fourthChildNode(id: number, childNodes: any, name: string, parentId: any) {

    let twoD = {
      parentId: parentId,
      symptomId: id
    }
    this.twoDimensionalParent.push(twoD)

    if (childNodes == null || childNodes.length == 0) {
      this.isShowChildNodes1 = false;
      this.isShowChildNodes = false;
      this.isShowChildNodes2 = true;
      this.isShowChildNodes3 = false;
      this.isShowChildNodes4 = false;
      this.isShowChildNodes5 = false;
      if (this.selectedSymptomIdlist.includes(id) || this.parentIdList.includes(id)) {
        this.symptomsSelected--;

        this.selectedSymptomIdlist.splice(id, 2);

        //  this.parentIdList.splice(ind,2)
        this.parentIdList = this.parentIdList.filter((key) => {
          return key != id
        })


        if (this.symptomsSelected == 0) {
          this.selectedSymptomIdlist = [];
          this.oldParent = this.parentIdList
          this.parentIdList = [];

        }

        this.oneDimensionalParent = []
        const index = this.selectedSymptomIdlist.indexOf(id, 0);
        // const index1 = this.oneDimensionalParent.indexOf(id, 0);
        const index2 = this.twoDimensionalParent.findIndex((o: any) => {
          return o.symptomId == id
        })
        this.tempSymptomChildId = this.tempSymptomChildId.filter((data: any) => {
          return data.childSymptomId != id
        })


        for (let twod of this.tempSymptomChildId) {
          this.oneDimensionalParent.push(twod.symptomId)
        }
        this.oneDimensionalParent = this.oneDimensionalParent.filter((data: any, index: any) => {
          return this.oneDimensionalParent.indexOf(data) === index
        })

        this.parentIdList = this.oneDimensionalParent
        if (index > -1 || index2 > -1) {
          this.selectedSymptomIdlist.splice(index, 1);

          let tempTwoDimensionalParent: any = []
          for (let i of this.twoDimensionalParent) {
            if (i.symptomId != id) {
              tempTwoDimensionalParent.push(i)
            }
          }


          this.uniqueSelectedIdList = new Set(this.selectedSymptomIdlist);
          this.api.symptomSubject.next(this.symptomsSelected);
          this.api.listsymptomSubject.next(this.selectedSymptomIdlist);
          this.api.ParentsymptomSubject.next(this.parentIdList);
          this.api.tempSymptomSubject.next(this.tempSymptomChildId)
          return;
        }
      } else {
        this.symptomsSelected++;

        this.tempParentId = parentId
        var tempSymptomId = id
        this.tempSymptomChildId.push({ symptomId: id, childSymptomId: id })
        while (this.tempParentId != tempSymptomId) {
          this.tempSymptomChildId.push({ symptomId: this.tempParentId, childSymptomId: id })
          tempSymptomId = this.tempParentId;
          for (let data of this.twoDimensionalParent) {
            if (data.symptomId == this.tempParentId) {

              this.tempParentId = data.parentId
              break;
            }
          }

        }

        if (this.symptomsSelected > 0) {
          for (let twod of this.tempSymptomChildId) {
            this.oneDimensionalParent.push(twod.symptomId)
          }
          this.oneDimensionalParent = this.oneDimensionalParent.filter((data: any, index: any) => {
            return this.oneDimensionalParent.indexOf(data) === index
          })
          this.parentIdList = this.oneDimensionalParent
        }


        //this.parentIdList.push(id);
        this.api.ParentsymptomSubject.next(this.parentIdList)
        this.selectedSymptomIdlist.push(id);
        this.uniqueSelectedIdList = new Set(this.selectedSymptomIdlist);
        this.api.symptomSubject.next(this.symptomsSelected);
        this.api.listsymptomSubject.next(this.selectedSymptomIdlist)
        this.api.tempSymptomSubject.next(this.tempSymptomChildId)

        return;
      }
    } else if (childNodes && childNodes.length > 0) {
      this.showArrow = true
      this.showArrowFourthFuncCall = true
      this.showArrowThirdFuncCall = false
      this.showArrowFirstFuncCall = false;
      this.showArrowSecFuncCall = false;
      this.isShowChildNodes1 = false;
      this.isShowChildNodes = false;
      this.isShowChildNodes2 = false;
      this.isShowChildNodes3 = true;
      this.isShowChildNodes4 = false;
      this.isShowChildNodes5 = false;
      this.childList3 = childNodes;
      this.isHideLink2 = false;
      this.isHideLink = false;
      this.isShowText = false;
      this.isShowText1 = false;
      this.isShowText2 = false;
      this.isShowText3 = true;
      this.isHideLink1 = false;
      this.isHideLink2 = false;
      this.isShowLink3 = name;
      // this.parentIdList.push(id);
      this.uniqueSelectedIdList = new Set(this.parentIdList);
      this.api.symptomSubject.next(this.symptomsSelected);
      this.api.ParentsymptomSubject.next(this.parentIdList)
      this.api.tempSymptomSubject.next(this.tempSymptomChildId)
    }


  }


  fifthChildNode(id: number, childNodes: any, name: string, parentId: any) {

    let twoD = {
      parentId: parentId,
      symptomId: id
    }
    this.twoDimensionalParent.push(twoD)

    if (childNodes == null || childNodes.length == 0) {
      this.isShowChildNodes1 = false;
      this.isShowChildNodes = false;
      this.isShowChildNodes2 = false;
      this.isShowChildNodes3 = true;
      this.isShowChildNodes4 = false;
      this.isShowChildNodes5 = false;
      if (this.selectedSymptomIdlist.includes(id) || this.parentIdList.includes(id)) {
        this.symptomsSelected--;

        this.selectedSymptomIdlist.splice(id, 2);

        //  this.parentIdList.splice(ind,2)
        this.parentIdList = this.parentIdList.filter((key) => {
          return key != id
        })


        if (this.symptomsSelected == 0) {
          this.selectedSymptomIdlist = [];
          this.oldParent = this.parentIdList
          this.parentIdList = [];

        }

        this.oneDimensionalParent = []
        const index = this.selectedSymptomIdlist.indexOf(id, 0);
        // const index1 = this.oneDimensionalParent.indexOf(id, 0);
        const index2 = this.twoDimensionalParent.findIndex((o: any) => {
          return o.symptomId == id
        })
        this.tempSymptomChildId = this.tempSymptomChildId.filter((data: any) => {
          return data.childSymptomId != id
        })


        for (let twod of this.tempSymptomChildId) {
          this.oneDimensionalParent.push(twod.symptomId)
        }
        this.oneDimensionalParent = this.oneDimensionalParent.filter((data: any, index: any) => {
          return this.oneDimensionalParent.indexOf(data) === index
        })

       this.parentIdList = this.oneDimensionalParent
        if (index > -1 || index2 > -1) {
          this.selectedSymptomIdlist.splice(index, 1);

          let tempTwoDimensionalParent: any = []
          for (let i of this.twoDimensionalParent) {
            if (i.symptomId != id) {
              tempTwoDimensionalParent.push(i)
            }
          }


          this.uniqueSelectedIdList = new Set(this.selectedSymptomIdlist);
          this.api.symptomSubject.next(this.symptomsSelected);
          this.api.listsymptomSubject.next(this.selectedSymptomIdlist);
          this.api.ParentsymptomSubject.next(this.parentIdList);
          this.api.tempSymptomSubject.next(this.tempSymptomChildId)
          return;
        }
      } else {
        this.symptomsSelected++;

        this.tempParentId = parentId
        var tempSymptomId = id
        this.tempSymptomChildId.push({ symptomId: id, childSymptomId: id })
        while (this.tempParentId != tempSymptomId) {
          this.tempSymptomChildId.push({ symptomId: this.tempParentId, childSymptomId: id })
          tempSymptomId = this.tempParentId;
          for (let data of this.twoDimensionalParent) {
            if (data.symptomId == this.tempParentId) {

              this.tempParentId = data.parentId
              break;
            }
          }

        }

        if (this.symptomsSelected > 0) {
          for (let twod of this.tempSymptomChildId) {
            this.oneDimensionalParent.push(twod.symptomId)
          }
          this.oneDimensionalParent = this.oneDimensionalParent.filter((data: any, index: any) => {
            return this.oneDimensionalParent.indexOf(data) === index
          })
          this.parentIdList = this.oneDimensionalParent
        }


        //this.parentIdList.push(id);
        this.api.ParentsymptomSubject.next(this.parentIdList)
        this.selectedSymptomIdlist.push(id);
        this.uniqueSelectedIdList = new Set(this.selectedSymptomIdlist);
        this.api.symptomSubject.next(this.symptomsSelected);
        this.api.listsymptomSubject.next(this.selectedSymptomIdlist)
        this.api.tempSymptomSubject.next(this.tempSymptomChildId)
        return;
      }
    } else if (childNodes && childNodes.length > 0) {
      this.showArrow = true
      this.showArrowFifthFuncCall = true;
      this.showArrowFourthFuncCall = false;
      this.showArrowThirdFuncCall = false;
      this.showArrowFirstFuncCall = false;
      this.showArrowSecFuncCall = false;
      this.isShowChildNodes1 = false;
      this.isShowChildNodes = false;
      this.isShowChildNodes2 = false;
      this.isShowChildNodes3 = false;
      this.isShowChildNodes4 = true;
      this.isShowChildNodes5 = false;
      this.childList4 = childNodes;
      this.isHideLink2 = false;
      this.isHideLink = false;
      this.isShowText = false;
      this.isShowText1 = false;
      this.isShowText2 = false;
      this.isShowText3 = false;
      this.isShowText4 = true;
      this.isHideLink1 = false;
      this.isHideLink2 = false;
      this.isHideLink3 = false;
      this.isShowLink4 = name;
      this.parentIdList.push(id);
      this.uniqueSelectedIdList = new Set(this.parentIdList);
      this.api.symptomSubject.next(this.symptomsSelected);
      this.api.ParentsymptomSubject.next(this.parentIdList)
      this.api.tempSymptomSubject.next(this.tempSymptomChildId)
    }
  }


  sixthChildNode(id: number, childNodes: any, name: string, parentId: any) {

    let twoD = {
      parentId: parentId,
      symptomId: id
    }
    this.twoDimensionalParent.push(twoD)

    if (childNodes == null || childNodes.length == 0) {
      this.isShowChildNodes1 = false;
      this.isShowChildNodes = false;
      this.isShowChildNodes2 = false;
      this.isShowChildNodes3 = false;
      this.isShowChildNodes4 = true;
      this.isShowChildNodes5 = false;
      if (this.selectedSymptomIdlist.includes(id) || this.parentIdList.includes(id)) {
        this.symptomsSelected--;

        this.selectedSymptomIdlist.splice(id, 2);

        //  this.parentIdList.splice(ind,2)
        this.parentIdList = this.parentIdList.filter((key) => {
          return key != id
        })


        if (this.symptomsSelected == 0) {
          this.selectedSymptomIdlist = [];
          this.oldParent = this.parentIdList
          this.parentIdList = [];

        }

        this.oneDimensionalParent = []
        const index = this.selectedSymptomIdlist.indexOf(id, 0);
        // const index1 = this.oneDimensionalParent.indexOf(id, 0);
        const index2 = this.twoDimensionalParent.findIndex((o: any) => {
          return o.symptomId == id
        })
        this.tempSymptomChildId = this.tempSymptomChildId.filter((data: any) => {
          return data.childSymptomId != id
        })


        for (let twod of this.tempSymptomChildId) {
          this.oneDimensionalParent.push(twod.symptomId)
        }
        this.oneDimensionalParent = this.oneDimensionalParent.filter((data: any, index: any) => {
          return this.oneDimensionalParent.indexOf(data) === index
        })

        this.parentIdList = this.oneDimensionalParent
        if (index > -1 || index2 > -1) {
          this.selectedSymptomIdlist.splice(index, 1);

          let tempTwoDimensionalParent: any = []
          for (let i of this.twoDimensionalParent) {
            if (i.symptomId != id) {
              tempTwoDimensionalParent.push(i)
            }
          }


          this.uniqueSelectedIdList = new Set(this.selectedSymptomIdlist);
          this.api.symptomSubject.next(this.symptomsSelected);
          this.api.listsymptomSubject.next(this.selectedSymptomIdlist);
          this.api.ParentsymptomSubject.next(this.parentIdList);
          this.api.tempSymptomSubject.next(this.tempSymptomChildId)
          return;
        }
      } else {
        this.symptomsSelected++;

        this.tempParentId = parentId
        var tempSymptomId = id
        this.tempSymptomChildId.push({ symptomId: id, childSymptomId: id })
        while (this.tempParentId != tempSymptomId) {
          this.tempSymptomChildId.push({ symptomId: this.tempParentId, childSymptomId: id })
          tempSymptomId = this.tempParentId;
          for (let data of this.twoDimensionalParent) {
            if (data.symptomId == this.tempParentId) {

              this.tempParentId = data.parentId
              break;
            }
          }

        }

        if (this.symptomsSelected > 0) {
          for (let twod of this.tempSymptomChildId) {
            this.oneDimensionalParent.push(twod.symptomId)
          }
          this.oneDimensionalParent = this.oneDimensionalParent.filter((data: any, index: any) => {
            return this.oneDimensionalParent.indexOf(data) === index
          })
          this.parentIdList = this.oneDimensionalParent
        }


        //this.parentIdList.push(id);
        this.api.ParentsymptomSubject.next(this.parentIdList)
        this.selectedSymptomIdlist.push(id);
        this.uniqueSelectedIdList = new Set(this.selectedSymptomIdlist);
        this.api.symptomSubject.next(this.symptomsSelected);
        this.api.listsymptomSubject.next(this.selectedSymptomIdlist)
        this.api.tempSymptomSubject.next(this.tempSymptomChildId)
        return;
      }
    } else if (childNodes && childNodes.length > 0) {
      this.showArrow = true
      this.showArrowSixthFuncCall = true
      this.showArrowFifthFuncCall = false;
      this.showArrowFourthFuncCall = false;
      this.showArrowThirdFuncCall = false;
      this.showArrowFirstFuncCall = false;
      this.showArrowSecFuncCall = false;
      this.isShowChildNodes1 = false;
      this.isShowChildNodes = false;
      this.isShowChildNodes2 = false;
      this.isShowChildNodes3 = false;
      this.isShowChildNodes4 = true;
      this.childList4 = childNodes;
      this.isHideLink2 = false;
      this.isHideLink = false;
      this.isShowText = false;
      this.isShowText1 = false;
      this.isShowText2 = false;
      this.isShowText3 = false;
      this.isShowText4 = false;
      this.isShowText5 = true;
      this.isHideLink1 = false;
      this.isHideLink2 = false;
      this.isHideLink3 = false;
      this.isHideLink4 = false;
      this.isShowLink5 = name;
      // this.parentIdList.push(id);
      this.uniqueSelectedIdList = new Set(this.parentIdList);
      this.api.symptomSubject.next(this.symptomsSelected);
      this.api.ParentsymptomSubject.next(this.parentIdList);
      this.api.tempSymptomSubject.next(this.tempSymptomChildId)
    }
  }

  arrowFunction() {

    this.api.symptomName.subscribe((data) => {
      this.symptomSelectedFirstName = data
    })
    this.isAvailable = true
    if (this.showArrowFirstFuncCall) {

      this.crumbArrowFirst();

    } else if (this.showArrowSecFuncCall) {

      this.crumbArrowSecond();


    } else if (this.showArrowThirdFuncCall) {
      this.crumbArrowThird();

    } else if (this.showArrowFourthFuncCall) {

      this.crumbArrowFourth();
    } else if (this.showArrowFifthFuncCall) {

      this.crumbArrowFifth();

    }



  }

  // hotlineSubmit() {
  //   this.infotab = false;
  //   this.api.infotab.next(this.infotab)
  //   this.hintstab = false;
  //   this.api.hintstab.next(this.hintstab)
  //   this.submittab = true;
  //   this.api.submittab.next(this.submittab)
  // }
  // hotlineSubmit() {
  //   // this.infotab = false;
  //   // this.api.infotab.next(this.infotab)
  //   // this.hintstab = false;
  //   // this.api.hintstab.next(this.hintstab)
  //   // this.submittab = true;
  //   // this.api.submittab.next(this.submittab)
  //   const request = {
  //     "vin": this.vin,
  //     "paCode": this.dealerCode,
  //     "country": this.countrythree,
  //     "language": this.language
  //   }
  //   // this.api.getGlobalManagedServicesDetails(this.ptsEngineServiceResponseObj.id).subscribe((data) => {
  //   //   this.globalManagedRes=data;
  //   //   if (this.globalManagedRes.length > 0){
  //   //     this.isEnableService =true;
  //   //  } else {
  //   //      this.isEnableService =false;
  //   //  }
     
  //      this.api.getVindetails(request).subscribe((data) => {
  //       this.vindetails = data
  //       console.log(this.vindetails)
  //       this.modelYear = this.vindetails.modelYear
  //       console.log(this.modelYear, "modelYear")
  //       this.vehicle = this.vindetails.vehicleLineDescription
  //       //const newWindow = window.open('https://www.gtac.dealerconnection.com/GTACUiWeb/pages/submitTSR.faces?Year='+this.modelYear+'&BD=09-10-2015&LANG=EN-US&Transmission=6+Speed+Auto+Trans+6F35&Model=Mondeo+2014+-&Contactid=&vin=WF0EXXWPCEFU07509&USERID=g-gbr&WDS=15-10-2015&Engine=2.0L+EcoBoost+%28240PS%29&Body=5+Door+Saloon&Symptom_codes=&GEO=GBR&PACODE=GBR50089AA&dswid=-9183','_blank', 'width=700,height=700');
  //       const newWindow = window.open('https://www.gtac.dealerconnection.com/GTACUiWeb/pages/submitTSR.faces?LANG=' + this.language + '-US&Contactid=&vin=' + this.vin + '&USERID=' + this.username + '&Symptom_codes=12&GEO=' + this.countrythree + '&PACODE=' + this.dealerCode + '&countryCode=' + this.countrythree + '&Model=' + this.vehicle + '&Year=' + this.modelYear, '_blank', 'width=700,height=700');
  //     }
  //     )
  //   console.log(this.modelYear, "modelYear")
  //   // this.router.navigateByUrl(["https://www.gtac.dealerconnection.com/GTACUiWeb/pages/submitTSR.faces?Year=2016&BD=09-10-2015&LANG=EN-US&Transmission=6+Speed+Auto+Trans+6F35&Model=Mondeo+2014+-&Contactid=&vin=WF0EXXWPCEFU07509&USERID=g-gbr&WDS=15-10-2015&Engine=2.0L+EcoBoost+%28240PS%29&Body=5+Door+Saloon&Symptom_codes=&GEO=GBR&PACODE=GBR50089AA&dswid=-9183"])

  // }



}
